import { Outlet } from 'react-router-dom';

import CompactLayout from 'src/layouts/compact';

import Page404 from 'src/pages/404';

export const otherRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [{ path: '404', element: <Page404 /> }],
  },
];
